import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccountResourceControlPolicies } from '../../generated/fragments';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetResourceControlPoliciesQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetResourceControlPoliciesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, resourceControlPolicies?: { __typename?: 'ResourceControlPolicies', shareDefaultExpirySeconds?: number | null, shareDomainAccessEnabled: boolean, accessRequestsEnabled?: boolean | null, downloads?: { __typename?: 'DownloadsSettings', shareDownloadingEnabled?: boolean | null, adminCanEnableInShares?: boolean | null, fullAccessCanEnableInShares?: boolean | null, editAndShareCanEnableInShares?: boolean | null, adminInternal?: boolean | null, fullAccessInternal?: boolean | null, editAndShareInternal?: boolean | null } | null, sharePassphrase?: { __typename?: 'SharePassphraseSettings', required?: boolean | null, adminCanDisableInShares?: boolean | null, fullAccessCanDisableInShares?: boolean | null, editAndShareCanDisableInShares?: boolean | null } | null, shareAccess?: { __typename?: 'ShareAccessSettings', default?: Types.ShareAccess | null, minimum?: Types.ShareAccess | null, adminCanDisableInShares?: boolean | null, fullAccessCanDisableInShares?: boolean | null, editAndShareCanDisableInShares?: boolean | null } | null } | null } | null };


export const GetResourceControlPolicies = /*#__PURE__*/ gql`
    query GetResourceControlPolicies($accountId: ID!) {
  account(accountId: $accountId) {
    id
    ...AccountResourceControlPolicies
  }
}
    ${AccountResourceControlPolicies}` as unknown as DocumentNode<GetResourceControlPoliciesQuery, GetResourceControlPoliciesQueryVariables>;

          

          export const useGetResourceControlPoliciesQuery = (options?:QueryHookOptions<GetResourceControlPoliciesQuery, GetResourceControlPoliciesQueryVariables>) => useQuery(GetResourceControlPolicies, options);

          

          export type GetResourceControlPoliciesQueryOptions = QueryHookOptions<GetResourceControlPoliciesQuery, GetResourceControlPoliciesQueryVariables>;

          

          export const useGetResourceControlPoliciesLazyQuery = (options?:LazyQueryHookOptions<GetResourceControlPoliciesQuery, GetResourceControlPoliciesQueryVariables>) => useLazyQuery(GetResourceControlPolicies, options);

          

          export type GetResourceControlPoliciesQueryResult = ReturnType<typeof useGetResourceControlPoliciesQuery>;

          
